import React from "react";
import Webhooks from "../Settings/_components/Webhooks";

const WebhooksPage: React.FC = () => {
  return (
    <div className="p-6 space-y-4 flex flex-col justify-center items-center">
      <h1 className="text-3xl text-[#212121]">Webhooks</h1>
      <div className="w-full max-w-4xl mt-2">
        <Webhooks />
      </div>
    </div>
  );
};

export default WebhooksPage;

